"use strict";

$(document).ready(function () {
  $('.fl-home__slider').slick({
    centerMode: true,
    adaptiveHeight: false,
    useTransform: false,
    centerPadding: '30%',
    prevArrow: "<img class='prev-arrow' src='../images/slider/arrows/left-arrow.svg'/>",
    nextArrow: "<img class='next-arrow' src='../images/slider/arrows/right-arrow.svg'/>",
    slidesToShow: 1,
    inifinte: true,
    responsive: [{
      breakpoint: 768,
      settings: {
        arrows: true,
        useTransform: false,
        centerMode: true,
        adaptiveHeight: false,
        prevArrow: "<img class='prev-arrow' src='../images/slider/arrows/left-arrow.svg'/>",
        nextArrow: "<img class='next-arrow' src='../images/slider/arrows/right-arrow.svg'/>",
        centerPadding: '25%',
        slidesToShow: 1
      }
    }, {
      breakpoint: 480,
      settings: {
        arrows: true,
        centerMode: true,
        adaptiveHeight: false,
        useTransform: false,
        centerPadding: '20%',
        slidesToShow: 1,
        prevArrow: "<img class='prev-arrow' src='../images/slider/arrows/left-arrow.svg'/>",
        nextArrow: "<img class='next-arrow' src='../images/slider/arrows/right-arrow.svg'/>"
      }
    }]
  });
});
$(document).ready(function () {
  $('.fhbcs__slider-desktop-image').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    //autoplaySpeed: 12000,
    fade: true,
    asNavFor: '.fhbcs__slider-desktop-info'
  });
  $('.fhbcs__slider-desktop-info').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    asNavFor: '.fhbcs__slider-desktop-image',
    dots: true,
    prevArrow: $("#desktop-slider-prev"),
    nextArrow: $("#desktop-slider-next"),
    //appendDots: $(".slick-dots"),
    autoplay: false
    //autoplaySpeed: 12000
  });
});

var ticker = document.querySelector('.ticker'),
  list = document.querySelector('.ticker__list'),
  clone = list.cloneNode(true);
ticker.append(clone);